import Vue from 'vue';
import Vuex from 'vuex';
import Web3 from 'web3';
import { createStore } from 'vuex';
import { copyText, getInviteCodeFromURL } from '@/utils/pettern.js'
import { invite, coin,web3_api } from '@/api';
import { Toast } from 'vant';
import configURL from "@/utils/configUrl";
import { NetConfig } from '@/config/constants/netWorkConfig.js';
import createPersistedState from 'vuex-persistedstate';
//模块化store
// import Sys from '../components/modal/store';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    provider: {},
    account: '',
    net: 0,
    gasPrice: 0,
    gasPriceType: 3,
    slippage: 0.1,
    deadline: 20,
    multipath: true,
    transactions: {},
    block: 0,
    expert: false,
    inviteUrl: '',
    userInfo: {},
    parent_id: 0,
    pidCode: '',
    netWorkConfig: NetConfig[0],
  },
  mutations: {
    SETPROVIDER: (state, provider) => {
      state.provider = provider;
    },
    SETGASTYPE: (state, gasPriceType) => {
      state.gasPriceType = gasPriceType;
    },
    SETNETWORKCINFIG: (state, netWorkConfig) => {
      state.netWorkConfig = netWorkConfig;
    },
    SETBLOCK: (state, block) => {
      state.block = block;
    },
    DELETETRANSACTIONS: state => {
      state.transactions = {};
    },
    SETEXPORT: (state, provider) => {
      state.expert = provider
    },
    SETTRANSACTIONS: (state, transactionsDetail) => {
      let tempObj = JSON.parse(JSON.stringify(state.transactions));
      tempObj[transactionsDetail.hash] = transactionsDetail;
      state.transactions = tempObj;
    },
    SETTRANSACTIONSRECEIPT: (state, transactionsDetail) => {
      let tempObj = JSON.parse(JSON.stringify(state.transactions));
      tempObj[transactionsDetail.hash].receipt = transactionsDetail.receipt;
      state.transactions = tempObj;
    },
    SETACCOUNTS: (state, account) => {

      state.account = account;
    },
    SETUSERINFO: (state, userInfo) => {
      state.userInfo = userInfo;

      state.parent_id = userInfo.parent_id;

      if (userInfo.invite_code != '') {
        state.inviteUrl = `${configURL.initveUrl}/#/HomeIndex?invite_Code=${state.userInfo.invite_code}`;
      } 
    },
    SETINVITEURL: (state, inviteUrl) => {
      state.inviteUrl = inviteUrl;
    },
    SETPIDCODE: (state, pidCode) => {
      state.pidCode = pidCode;
    },

    SETNET: (state, net) => {
      state.net = net;
    },
    SET_GASPRICE(state, gasPrice) {
      state.gasPrice = gasPrice;
    },
    SET_SLIPPAGE(state, slippage) {
      state.slippage = slippage;
    },
    SET_DEADLINE(state, deadline) {
      state.deadline = deadline;
    },
    SET_MULTIPATH(state, multipath) {
      state.multipath = multipath;
    },
    SET_EXPORT(state, ex) {
      state.expert = ex
    }
  },
  actions: {
    AccountGetFunc({ dispatch, commit }, account) {
      commit('SETACCOUNTS', account);
      dispatch('getAccount');

    },
    async getAccount({ dispatch, commit }) {
     
    },
    GetgetInviteCode({ dispatch, commit }) {
      let params = getInviteCodeFromURL('invite_Code')
      console.log(params);

      if (params) {
        commit('SETPIDCODE', params);
        dispatch('userbind');
      }

    },
    async userbind({ dispatch, commit }) {
      if (this.state.pidCode == '') return;
      if (this.state.parent_id != 0) return;
      let sign = null
      try {
        let web3 = new Web3(window.ethereum);
        sign = await web3.eth.personal.sign(web3.utils.fromUtf8('User Bind'), this.state.account)
      } catch (error) {
        return;
      }
      let data = {
        invite_code: this.state.pidCode,
        signature: sign
      }
      invite.userBind(data,this.state.account).then(res => {
        Toast(res.msg);
        if (res.code == 200) {
          dispatch('getAccount')
        }
      })
    },
    async changeWallet({ dispatch, commit }) {

      if (Object.keys(this.state.netWorkConfig).length === 0) {
        commit('SETNETWORKCINFIG', NetConfig[0]);
      } else {
        // 根据当前配置的chainId在NetConfig中查找匹配项
        const matchingConfig = NetConfig.find(config =>
          config.chainId === this.state.netWorkConfig.chainId
        );

        // 如果找到匹配项则使用，否则使用默认配置
        commit('SETNETWORKCINFIG', matchingConfig || NetConfig[0]);
      }
      console.log(this.state.netWorkConfig.chainId,'this.state.netWorkConfig.chainId');
      
      web3_api.switchEthereumChain(this.state.netWorkConfig.chainId).then(res => {
      })

    },
    async setWallet() {
      var web3Provider;
      if (window.ethereum) {
        web3Provider = window.ethereum;
        try {
          await web3Provider.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                "chainId": String(this.state.netWorkConfig.chainId),
                "chainName": this.state.netWorkConfig.NetWorkName,
                "nativeCurrency": {
                  "name": this.state.netWorkConfig.TokenBNB.name,
                  "symbol": String(this.state.netWorkConfig.TokenBNB.name),
                  decimals: this.state.netWorkConfig.TokenBNB.decimals,
                },
                rpcUrls: [this.state.netWorkConfig.Url],
              },
            ],
          });
          await web3Provider.enable();
        } catch (error) {
          console.error('User denied account access');
        }
      }
    },
    async setWebProvider({ dispatch, commit }) {
      var web3Provider;
      if (window.ethereum) {
        web3Provider = window.ethereum;
        try {
          // 请求用户授权
          await web3Provider.request({
            method: 'eth_requestAccounts',
            params: [
              {
                chainId: this.state.netWorkConfig.chainId,
                chainName: this.state.netWorkConfig.NetWorkName,
                nativeCurrency: {
                  name: this.state.netWorkConfig.key,
                  symbol: this.state.netWorkConfig.key,
                  decimals: 18,
                },
                rpcUrls: [this.state.netWorkConfig.Url],
                blockExplorerUrls: [`https://www.oklink.com/okexchain`],
              },
            ],
          });
          // await web3Provider.request({
          //   method: 'wallet_addEthereumChain',
          //   params: [
          //     {
          //       chainId: '0x3',
          //       chainName: 'Ropsten 测试网络',
          //       nativeCurrency: {
          //         name: 'ETH',
          //         symbol: 'eth',
          //         decimals: 18,
          //       },
          //       rpcUrls: ['https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'],
          //       blockExplorerUrls: [`https://ropsten.etherscan.io`],
          //     },
          //   ],
          // });
          await web3Provider.enable();
        } catch (error) {
          // 用户不授权时
          console.error('User denied account access');
        }
        const web3js = new Web3(web3Provider); //web3js就是你需要的web3实例
        commit('SETPROVIDER', web3js);
        web3js.eth.net.getId(function (error, result) {
          if (!error) {
            console.log(result, '网络'); //授权成功后result能正常获取到账号了
            commit('SETNET', result);
          }
        });
        web3js.eth.getAccounts( (error, result) => {
          if (!error&&this.state.account=='') {
            console.log(result, '账号'); //授权成功后result能正常获取到账号了

            dispatch('AccountGetFunc', (result[0]));
          }
        });
        web3Provider.on('networkChanged', function (networkIDstring) {
          commit('SETNET', networkIDstring);

        });
        web3Provider.on('accountsChanged', function (accounts) {
          dispatch('AccountGetFunc', (accounts[0]));
  
          console.log('切换账号', accounts);
        });
      }
    },
  },
  plugins: [
    createPersistedState({
      paths: ['gasPrice', 'slippage', 'deadline', 'multipath', 'transactions', 'block', "expert", "netWorkConfig", "gasPriceType"],
    }),
  ],
});
